/*
 * NextGenn engine · what you were looking at (sections/ngs-seen.liquid).
 *
 * The list lives in this browser and nowhere else. Opening a product page puts
 * its handle at the front; the section reveals the cards for the handles in the
 * list, minus the bottle currently being looked at, capped.
 *
 * Every read and write is wrapped: in a private window localStorage can throw
 * on access, not just come back empty, and a shop that breaks in a private
 * window breaks for everybody who is shopping for a present.
 */
if (!customElements.get('ngs-seen')) {
  customElements.define(
    'ngs-seen',
    class NGSSeen extends HTMLElement {
      static KEY = 'ngs-seen';

      static read() {
        try {
          var raw = window.localStorage.getItem(NGSSeen.KEY);
          var list = raw ? JSON.parse(raw) : [];
          return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string'; }) : [];
        } catch (error) {
          return [];
        }
      }

      static remember(handle) {
        if (!handle) return;
        try {
          var list = NGSSeen.read().filter(function (h) { return h !== handle; });
          list.unshift(handle);
          window.localStorage.setItem(NGSSeen.KEY, JSON.stringify(list.slice(0, 12)));
        } catch (error) {
          /* nothing to remember it with; the section simply shows nothing */
        }
      }

      connectedCallback() {
        this.cards = Array.prototype.slice.call(this.querySelectorAll('.ngs-seen__card'));
        if (!this.cards.length) return;
        var here = this.dataset.this || '';
        var most = Number(this.dataset.most) || 4;

        /* the list as it was BEFORE this page is added, or the bottle in front
           of them would be the first thing in "you were looking at" */
        var seen = NGSSeen.read().filter(function (h) { return h !== here; });
        if (here) NGSSeen.remember(here);

        var shown = 0;
        var order = {};
        seen.forEach(function (h, i) { order[h] = i; });
        this.cards
          .filter(function (c) { return order[c.dataset.handle] !== undefined; })
          .sort(function (a, b) { return order[a.dataset.handle] - order[b.dataset.handle]; })
          .forEach(function (card) {
            if (shown >= most) return;
            card.hidden = false;
            card.parentNode.appendChild(card);
            shown += 1;
          });
        this.hidden = shown === 0;
      }
    }
  );
}
